<template>
    <div>

        <rkm-form
            ref="FormFaturamento"
            show-legend
        >

            <rkm-area
                type="fieldset"
                title="Atendimento Domiciliar"
            >

                <FormAtendimentoDomiciliar
                    :data="data"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Funcionalidades"
            >
                <FormFuncionalidade
                    :data="data"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos"
            >
                <FormProcedimentos
                    :data="data"
                />
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Components
import FormAtendimentoDomiciliar from './components/atendimento-domiciliar/Form'
import FormFuncionalidade from './components/funcionalidade/Form'
import FormProcedimentos from './components/procedimentos/Form'

export default {
    components: {
        FormAtendimentoDomiciliar,
        FormFuncionalidade,
        FormProcedimentos,
    },
    computed: {
        validations() {
    
            return {}
        },
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        async validate() {

            return true
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    }
}
    
</script>